import { defineAbility } from '@casl/ability'
import { abilitiesPlugin } from '@casl/vue'
import type { App } from 'vue'
import { AppAbility } from './typing'

// eslint-disable-next-line @typescript-eslint/no-empty-function -- rules are populated later via ability.update() once the user's permissions are loaded
const ability = defineAbility<AppAbility>(() => {})

export function register(app: App) {
  app.use(abilitiesPlugin, ability, { useGlobalProperties: true })
}

declare module '@vue/runtime-core' {
  interface ComponentCustomProperties {
    $ability: AppAbility
    $can(this: this, ...args: Parameters<this['$ability']['can']>): boolean
  }
}

export { ability }
